export const manualPaymentCancelConstants = {
    MANUAL_PAYMENT_CANCEL_PENDING: 'MANUAL_PAYMENT_CANCEL_PENDING',
    MANUAL_PAYMENT_CANCEL_FULFILLED: 'MANUAL_PAYMENT_CANCEL_FULFILLED',
    MANUAL_PAYMENT_CANCEL_REJECTED: 'MANUAL_PAYMENT_CANCEL_REJECTED',
    MANUAL_PAYMENT_DETAIL_PENDING: 'MANUAL_PAYMENT_DETAIL_PENDING',
    MANUAL_PAYMENT_DETAIL_FULFILLED: 'MANUAL_PAYMENT_DETAIL_FULFILLED',
    MANUAL_PAYMENT_DETAIL_REJECTED: 'MANUAL_PAYMENT_DETAIL_REJECTED',
    MANUAL_PAYMENT_AUDIT_PENDING: 'MANUAL_PAYMENT_AUDIT_PENDING',
    MANUAL_PAYMENT_AUDIT_FULFILLED: 'MANUAL_PAYMENT_AUDIT_FULFILLED',
    MANUAL_PAYMENT_AUDIT_REJECTED: 'MANUAL_PAYMENT_AUDIT_REJECTED',
    MANUAL_PAYMENT_CANCEL_CLEAR: 'MANUAL_PAYMENT_CANCEL_CLEAR',
    MANUAL_PAYMENT_DETAIL_CLEAR: 'MANUAL_PAYMENT_DETAIL_CLEAR',
    MANUAL_PAYMENT_AUDIT_CLEAR: 'MANUAL_PAYMENT_AUDIT_CLEAR',
};
